export default "__VITE_ASSET__B5w52vlT__"